import App from './App'
import { worker } from './mocks/browser'
import 'prove-common/styles/index.css'
import { i18n } from 'prove-common'
import { bootstrapApp } from 'prove-common/bootstrap'
import { BASE_URL } from './constants'

await bootstrapApp({
  appId: 'provelab',
  App,
  baseUrl: BASE_URL,
  startWorker: () => worker.start(),
  testRoles: ['lab-only'],
  testUserName: 'Testbruker (admin)',
  onBeforeRender: () => i18n.changeLanguage('en')
})
